export const TITLE = 'Classes'
export const TIER_2_TITLE = 'Small Groups'
export const CREATE_CLASS_BUTTON_TEXT = 'Create a Class'
export const TRAINING_BUTTON_TEXT = 'Training Articles'
export const TILES_CONTAINER_CLASS_NAME = 'tiles-container'
